import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {first} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../../shared/services/authentication/authentication.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-password-forgot',
    templateUrl: './password-forgot.component.html',
    styleUrls: ['./password-forgot.component.css']
})
export class PasswordForgotComponent implements OnInit {


    passwordForgotForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    constructor(private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService,
                private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.passwordForgotForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        // reset login status
        this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.passwordForgotForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        if (this.f.email.errors) {
            if (this.f.email.errors.required) this.toastr.error(this.translate.instant('EMAIL_REQUIRED'), this.translate.instant('ERROR'));
            if (this.f.email.errors.email) this.toastr.error(this.translate.instant('EMAIL_INVALID'), this.translate.instant('ERROR'));

        }

        // stop here if form is invalid
        if (this.passwordForgotForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.initPassword(this.f.email.value.trim())
            .pipe(first())
            .subscribe(
                data => {

                    let t = this.toastr.success(this.translate.instant('EMAIL_LINK_SENT') + this.f.email.value.trim() + '. Please check your email.', this.translate.instant('SUCCESS'));
                    t.onHidden.subscribe(() => {
                        this.router.navigate([this.returnUrl]);
                    });

                },
                error => {
                    this.error = error;
                    this.loading = false;
                });
    }
}